import {Component, computed, OnInit} from '@angular/core';
import {ManageTaBaseComponent} from '../manage-ta-base-component.directive';
import {Button} from 'primeng/button';
import {DatePipe} from '@angular/common';
import {
  ItineraryDifferenceComparisonComponent
} from '../itinerary-difference-comparison/itinerary-difference-comparison.component';
import {ReactiveFormsModule} from '@angular/forms';
import {TaCostBubbleComponent} from '../../ta-cost-bubble/ta-cost-bubble.component';
import {toTAStatusText} from '../../../../util/app.types';
import {hasPendingDayTripPayment, resolveItineraryTravellerId} from '../../../../util/general.utils';
import {isSingleDayTripItinerary} from '../../../../util/itinerary.utils';
import {ManageTaDayTripPaymentTable} from '../manage-ta-day-trip-payment-table/manage-ta-day-trip-payment-table';
import {
  ManageTaPaymentActionsComponent
} from '../manage-ta-payment-actions/manage-ta-payment-actions.component';
import {TaApprovalsTableComponent} from '../ta-approvals-table/ta-approvals-table.component';

@Component({
  selector: 'manage-ta-finalise',
  imports: [
    Button,
    DatePipe,
    ItineraryDifferenceComparisonComponent,
    ReactiveFormsModule,
    TaCostBubbleComponent,
    ManageTaPaymentActionsComponent,
    ManageTaDayTripPaymentTable,
    TaApprovalsTableComponent,
  ],
  templateUrl: './manage-ta-finalise.component.html',
  styleUrl: './manage-ta-finalise.component.scss'
})
export class ManageTaFinaliseComponent extends ManageTaBaseComponent implements OnInit {
  // The outstanding payment actions themselves live in manage-ta-payment-actions; this page only
  // reassures the finaliser that a deduction that did apply has already been taken care of.
  isDeductionProcessed = computed(() => {
    return (this.taSubmission()?.approvals?.filter((approval) => (approval.actionContext === "OverPayment" && approval.status === "Actioned")) ?? []).length > 0
  });
  canFinalise = computed<boolean>(() => this.permissionService.canFinalise());

  /**
   * TAStore.ActionDayTripPaymentApprovalAsync finalises the TA itself when every traveller is on a
   * single day trip, so Finance does not finalise those while the payment is pending.
   */
  isComplianceFinalised = computed<boolean>(() => {
    const itineraries = this.latestItineraries();
    return hasPendingDayTripPayment(this.taSubmission())
      && itineraries.length > 0
      && itineraries.every(isSingleDayTripItinerary);
  });

  notes: string = '';

  // The itinerary comparison reads both the current itinerary and the full itinerary list, and this
  // page is reachable directly on refresh, so it owns the same fetches as the acquittal approval page.
  override ngOnInit() {
    super.ngOnInit();
    const id = resolveItineraryTravellerId(this.taSubmission(), this.store.user()?.id);
    if (id) {
      this.taSubmissionDatasource.loadTravellerItinerary(id);
    }

    this.taSubmissionDatasource.getAllItineraries();
  }

  confirmFinalise(action: 'finalise' | 'withhold'): void {
    this.confirmationServiceWrapper.finaliseConfirm(action, this.notes, this.store.taSubmission()).subscribe({
      next: () => {
        this.goBack();
      },
      error: err => {
        console.log(err);
      }
    });
  }

  protected readonly toTAStatusText = toTAStatusText;
}
